import React from 'react';

/**
 * ConversionSampleReportPreview
 *
 * Props:
 * - aggressive: aggressive annual savings number
 * - paybackMonths: ROI payback period in months
 * - onUpgrade: callback when the upgrade/report CTA is clicked
 */
const ConversionSampleReportPreview = ({ aggressive, paybackMonths, onUpgrade }) => {
  return (
    <div className="bg-gradient-to-br from-blue-50 to-indigo-100 rounded-xl p-8 mb-8">
      <div className="text-center mb-6">
        <h3 className="text-2xl font-bold text-gray-900 mb-2">See What $990 Gets You</h3>
        <p className="text-gray-600">Preview actual professional report results</p>
      </div>

      <div className="bg-white rounded-lg p-6 shadow-lg mb-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
          <div className="text-center p-4 bg-emerald-50 rounded-lg">
            <div className="text-2xl font-bold text-emerald-600">
              $
              {aggressive > 1000
                ? `${Math.round(aggressive / 1000)}K`
                : aggressive.toLocaleString()}
            </div>
            <div className="text-xs text-gray-600">Annual Energy Savings</div>
          </div>
          <div className="text-center p-4 bg-blue-50 rounded-lg">
            <div className="text-2xl font-bold text-blue-600">
              ${Math.round((aggressive * 0.6) / 1000)}K
            </div>
            <div className="text-xs text-gray-600">Productivity Gains</div>
          </div>
          <div className="text-center p-4 bg-purple-50 rounded-lg">
            <div className="text-2xl font-bold text-purple-600">
              {paybackMonths < 12
                ? `${paybackMonths} months`
                : `${Math.round(paybackMonths / 12)} years`}
            </div>
            <div className="text-xs text-gray-600">Payback Period</div>
          </div>
          <div className="text-center p-4 bg-green-50 rounded-lg">
            <div className="text-2xl font-bold text-green-600">
              ${Math.round((aggressive * 0.4) / 1000)}K+
            </div>
            <div className="text-xs text-gray-600">Available Grants</div>
          </div>
        </div>

        <div className="bg-gray-50 p-4 rounded-lg mb-4">
          <h4 className="font-bold text-gray-900 mb-2">Sample Implementation Roadmap:</h4>
          <div className="space-y-2 text-sm text-gray-700">
            <div className="flex justify-between">
              <span>✓ Compressed Air Optimization</span>
              <span className="font-medium">$89K/year, 1.1yr payback</span>
            </div>
            <div className="flex justify-between">
              <span>✓ LED Lighting + Smart Controls</span>
              <span className="font-medium">$67K/year, 1.3yr payback</span>
            </div>
            <div className="flex justify-between">
              <span>✓ HVAC System Upgrades</span>
              <span className="font-medium">$48K/year, 2.6yr payback</span>
            </div>
            <div className="flex justify-between text-gray-500">
              <span>+ 9 more detailed opportunities...</span>
              <span className="font-medium">$110K+/year</span>
            </div>
          </div>
        </div>

        <div className="flex justify-center space-x-4">
          <a
            href="https://consultant-comms.preview.emergentagent.com/sample-reports/patties-energy-assessment-report.html"
            target="_blank"
            rel="noopener noreferrer"
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
          >
            View Full Sample Report
          </a>
          <button
            onClick={onUpgrade}
            className="px-6 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition-colors font-bold"
          >
            Get Your Report - $990
          </button>
        </div>
      </div>

      <div className="text-center">
        <p className="text-sm text-gray-600">
          <strong>Real Results:</strong> Australian food manufacturing case study shows $990
          investment → $500K+ annual value
        </p>
      </div>
    </div>
  );
};

export default ConversionSampleReportPreview;


